import React from 'react';

function About() {
  return <div className='text-6xl mb-4'>Github Finder</div>;
}

export default About;
